import { api } from '../../services/api';
import { BrandKitState } from './brandKitSlice';

export const brandKitApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getBrandKits: builder.query<{ data: BrandKitState[], meta: { total: number, page: number, limit: number } }, { page?: number, limit?: number, search?: string } | void>({
            query: (params) => ({
                url: '/brand-kits',
                params: params || undefined,
            }),
            transformResponse: (response: { data: BrandKitState[], meta: any }) => ({
                data: response.data,
                meta: response.meta
            }),
            providesTags: ['BrandKits'],
        }),
        createBrandKit: builder.mutation<BrandKitState, Partial<BrandKitState>>({
            query: (body) => ({
                url: '/brand-kits',
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: BrandKitState }) => response.data,
            invalidatesTags: ['BrandKits'],
        }),
        getBrandKitById: builder.query<BrandKitState, string>({
            query: (id) => `/brand-kits/${id}`,
            transformResponse: (response: { data: BrandKitState }) => response.data,
            providesTags: (_result, _error, id) => [{ type: 'BrandKits', id }],
        }),
        updateBrandKit: builder.mutation<BrandKitState, { id: string; data: Partial<BrandKitState> }>({
            query: ({ id, data }) => ({
                url: `/brand-kits/${id}`,
                method: 'PATCH',
                body: data,
            }),
            transformResponse: (response: { data: BrandKitState }) => response.data,
            invalidatesTags: (_result, _error, { id }) => [
                { type: 'BrandKits', id },
                'BrandKits',
            ],
        }),
        uploadLogo: builder.mutation<{ url: string }, FormData>({
            query: (formData) => ({
                url: '/brand-kits/upload-logo',
                method: 'POST',
                body: formData,
            }),
            transformResponse: (response: { success: boolean, data: { url: string } }) => response.data,
        }),
    }),
});

export const {
    useGetBrandKitsQuery,
    useCreateBrandKitMutation,
    useGetBrandKitByIdQuery,
    useUpdateBrandKitMutation,
    useUploadLogoMutation,
} = brandKitApi;
